// extracted by mini-css-extract-plugin
export default {"brandingBar":"PartnerOverview_brandingBar__ghx2x","brandingDescription":"PartnerOverview_brandingDescription__uWvgo"};